<template>
    <div class="tab-content">
        <loading color="green" :active="loading" spinner="bar-fade-scale"/>
        <div class="tab-pane container fade" id="home">
            <form action>
                <div class="mail-input">
                    <input
                            type="email"
                            v-model="email"
                            class="input-modal-login"
                            name="mail"
                            :placeholder="word.your_email"
                    />
                    <i class="fas fa-envelope"></i>
                </div>
                <div class="key-input">
                    <input
                            type="password"
                            autocomplete="off"
                            v-model="password"
                            class="input-modal-login"
                            name="password"
                            :placeholder="word.your_password"
                    />
                    <i class="fas fa-lock"></i>
                </div>
                <div class="signin">
                    <button @click.prevent="login" class="login-btn mt-0">{{word.login}}</button>
                    <!--{{word.forget_password}}-->
                </div>
                <div class="modal-input">
          <span>
            {{word.forget_password}}
            <a href="#" :data-target="target" class="forget-pass">{{word.click_here}}</a>
          </span>
                </div>
                <!-- <div class="google">
                  <form action="?" method="POST">
                    <div class="g-recaptcha" data-sitekey="your_site_key"></div>
                  </form>
                </div>-->
                <div class="col-12 my-hr">
                    <span class="learn-h">{{word.or}}</span>
                    <hr/>
                </div>
                <a :href="googleRedirect" class="sign-google">
                    <i class="fab fa-google-plus-g pr-2"></i> {{word.login_by_google}}
                </a>
                <a :href="facebookRedirect" class="sign-facebook">
                    <i class="fab fa-facebook-f pr-2"></i> {{word.login_by_facebook}}
                </a>

                <div class="col-12 my-hr">
                    <span class="learn-h"></span>
                    <hr/>
                </div>
                <span class="modal-input">
                        <span class="ml-1">
                            {{word.dont_have_an_account}}
                        <a href="#" class="signup-link" @click.prevent="openRegisterModal">{{word.register}}</a>
                        </span>
                    </span>
            </form>
        </div>

    </div>
</template>

<script>
    export default {
        components: {},
        props: ['target', 'googleRedirect', 'facebookRedirect'],
        data() {
            return {
                loading: false,
                email: null,
                name: null,
                password: null,
                rules: false,
                text: window.text,
                word: window.word
            };
        },
        methods: {
            openRegisterModal() {
                $('#my-login-modal').modal('hide');
                $dispatch('open-register', {
                    genders: {
                        iAm: "man",
                        lookingFor: "woman"
                    },
                    startAge: 18,
                    endAge: 70,
                    countries: []
                })
            },
            login() {
                let self = this;
                self.loading = true;
                let data = {
                    email: self.email,
                    password: self.password
                };
                axios({
                    method: "post",
                    url: "/login",
                    data
                })
                    .then(res => {
                        self.loading = false;
                        if (res.data.ok) {
                            self.$toast.success(res.data.msg);
                            setTimeout(function () {
                                location.href = "/dashboard";
                            }, 1000);
                        } else {
                            self.$toast.error(res.data.msg);
                        }
                    })
                    .catch(err => {
                        self.loading = false;
                        console.log(err.response.data);
                        for (const item in err.response.data.errors) {
                            self.$toast.error(`${err.response.data.errors[item]}`);
                        }
                    });
            },
            register() {
                let self = this;
                self.loading = true;
                let data = {
                    email: self.email,
                    name: self.name,
                    password: self.password,
                    rules: self.rules
                };
                axios({
                    method: "post",
                    url: "/register",
                    data
                })
                    .then(res => {
                        self.loading = false;
                        if (res.data.ok) {
                            self.$toast.success(res.data.msg);
                            setTimeout(function () {
                                location.href = "/dashboard";
                            }, 1000);
                        } else {
                            self.$toast.error(res.data.msg);
                        }
                    })
                    .catch(err => {
                        self.loading = false;
                        console.log(err.response.data);
                        for (const item in err.response.data.errors) {
                            self.$toast.error(`${err.response.data.errors[item]}`);
                        }
                    });
            }
        }
    };
</script>

<style scoped>
    .signup-link {
        font-size: 13px !important;
        color: #16d1c8 !important;
        transition: 0.5s !important;
    }
</style>